import Choice from "@/components/fields/Choice";
import {useAppState} from "@/store";
import {useEffect, useState} from "react";
import {useValidation} from "@/validation";
import FieldError from "@/components/FieldError";

export default function ChoicePair({name, labels, values}) {

    const {state, setState} = useAppState()
    const [touched, setTouched] = useState(false)

    const {isFieldValid, invalidMessage, showErrors} = useValidation()

    const handleRadioChange = (key, {value}) => {
        setState((s) => {
            s.special[key] = value
        })
    }

    const valid = isFieldValid(`special.${name}`)
    const invalidMsg = invalidMessage(`special.${name}`)
    const showError = touched && !valid && invalidMsg

    useEffect(() => {
        if (showErrors) {
            setTouched(true)
        }
    }, [showErrors])


    return (
        <>
            <div className={"grid lg:auto-cols-fr lg:grid-flow-col gap-[16px] lg:gap-[32px] mt-[16px] lg:mt-[24px]"}>
                <Choice
                    name={`special.${name}`}
                    value={values[0]}
                    checked={state.special[name] === values[0]}
                    onChange={target => handleRadioChange(name, target)}
                >
                    {labels[0]}
                </Choice>
                <Choice
                    name={`special.${name}`}
                    value={values[1]}
                    checked={state.special[name] === values[1]}
                    onChange={target => handleRadioChange(name, target)}
                >
                    {labels[1]}
                </Choice>

            </div>
            {showError && (
                <div className={"text-center pt-2"}>
                    <FieldError message={invalidMsg} />
                </div>
            )}
        </>

    )
}
